import { useMemo } from 'react';
import { InlineSelect, MenuItem, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useStoreActions } from "../../../../contexts";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import { serviceBillingModel, serviceModel } from "../../../../models";
import { validateBillingDayOfMonth } from "../../../../models/service";
import { jsx as _jsx } from "react/jsx-runtime";
export const GetInlineUpfrontSelectTID = parentTestId => getTestIds({
  parentTestId,
  deprecatedTestIds: {
    InlineUpfrontSelectTestIds: {
      Root: "".concat(parentTestId, "is-billed-upfront-dropdown"),
      Option: value => value === 'true' ? "".concat(parentTestId, "is-billed-upfront-option-1") : "".concat(parentTestId, "is-billed-upfront-option-0")
    }
  }
});
function getUpfrontLabel(isBilledUpfront, isQuarterly) {
  if (isQuarterly) {
    return isBilledUpfront ? 'upfront on the 1st day of every quarter' : 'on the last day of every quarter';
  }
  return isBilledUpfront ? 'upfront' : 'at the end of the billing cycle';
}
export function InlineUpfrontSelect(_ref) {
  var _options$find;
  let {
    service,
    testid,
    disabled,
    isReadOnly,
    isActiveAgreement,
    TextComponent,
    onChange,
    onHasError,
    onBillingDayOfMonthError
  } = _ref;
  const {
    logBI
  } = useStoreActions();
  const {
    InlineUpfrontSelectTestIds
  } = useMemo(() => GetInlineUpfrontSelectTID(testid), [testid]);
  const {
    START_BILLING_AT_PHASE_2_INLINE
  } = useFeatureFlags();
  const isBilledUpfront = serviceBillingModel.isBilledUpfront(service.billing);
  const isQuarterly = serviceBillingModel.isQuarterly(service.billing);
  const options = useMemo(() => [{
    key: 'start',
    value: 'true',
    text: getUpfrontLabel(true, isQuarterly)
  }, {
    key: 'end',
    value: 'false',
    text: getUpfrontLabel(false, isQuarterly)
  }], [isQuarterly]);
  const currentValue = isBilledUpfront ? 'true' : 'false';
  const readOnlyValue = ((_options$find = options.find(opt => opt.value === currentValue)) === null || _options$find === void 0 ? void 0 : _options$find.text) || '';
  if (isReadOnly) {
    if (!START_BILLING_AT_PHASE_2_INLINE) {
      const Text = TextComponent || Typography;
      return /*#__PURE__*/_jsx(Text, {
        children: readOnlyValue
      });
    }
    return /*#__PURE__*/_jsx(Typography, {
      "data-testid": InlineUpfrontSelectTestIds.ViewOnlyText(),
      children: readOnlyValue
    });
  }
  return /*#__PURE__*/_jsx(InlineSelect, {
    skin: "primary",
    value: currentValue,
    "data-testid": InlineUpfrontSelectTestIds.Root(),
    disabled: disabled,
    onChange: function (_onChange) {
      function onChange(_x) {
        return _onChange.apply(this, arguments);
      }
      onChange.toString = function () {
        return _onChange.toString();
      };
      return onChange;
    }(e => {
      const newIsBilledUpfront = e.target.value === 'true';
      if (isActiveAgreement !== undefined) {
        logBI(11016, {
          isActiveAgreement,
          serviceId: service.id,
          isBilledUpfront: newIsBilledUpfront
        });
      }
      const billingDayOfMonth = serviceModel.billingDayOfMonth(service);
      if (billingDayOfMonth != null) {
        const hasError = validateBillingDayOfMonth(billingDayOfMonth, newIsBilledUpfront);
        onBillingDayOfMonthError === null || onBillingDayOfMonthError === void 0 || onBillingDayOfMonthError(hasError);
        onHasError === null || onHasError === void 0 || onHasError(service.id, hasError);
      }
      onChange(service.id, newIsBilledUpfront);
    }),
    SelectProps: {
      renderValue: value => getUpfrontLabel(value === 'true', isQuarterly)
    },
    children: options.map(_ref2 => {
      let {
        key,
        value,
        text
      } = _ref2;
      return /*#__PURE__*/_jsx(MenuItem, {
        value: value,
        "data-testid": InlineUpfrontSelectTestIds.Option(value),
        children: text
      }, key);
    })
  });
}